import { addHours, parseISO, sub } from 'date-fns';

const isExpiredInterval = process.env.PROPERTY_IS_EXPIRED;
const isExpiringInterval = process.env.PROPERTY_IS_EXPIRING;
const isNewInterval = process.env.PROPERTY_IS_NEW;


/**
 * Adds isExpiredInterval to the passed date and checks if the result is
 * greater than today
 *
 * @param string activatedAt | ISO 8601 Date string
 * @returns boolean
 */
export const getIsActive = activatedAt => {
    if (activatedAt == null) {
        return false;
    }

    const activatedDate = parseISO(activatedAt);

    return new Date() < addHours(activatedDate, isExpiredInterval);
};

/**
 * Adds isNewInterval to the passed date and checks if the result is
 * greater than or equal to today
 *
 * @param string activatedAt | ISO 8601 Date string
 * @returns boolean
 */
export const getIsNew = ({ activatedAt, activations = 1 }) => {
    if (activatedAt == null || activations > 1) {
        return false;
    }

    const activatedDate = parseISO(activatedAt);

    return addHours(activatedDate, isNewInterval) >= new Date();
};

/**
 * Checks if the passed date less than or equal to today
 *
 * @param string expiresAt | ISO 8601 Date string
 * @returns boolean
 */
export const getIsExpired = expiresAt => {
    if (expiresAt == null) {
        return false;
    }

    const expiresDate = parseISO(expiresAt);
    return expiresDate <= new Date();
};

/**
 * Subtracts the isExpiringInterval from the passed date
 * and checks if today is less than the passed date
 * AND greater than the result
 *
 * @param string expiresAt | ISO 8601 Date string
 * @returns boolean
 */
export const getIsExpiring = expiresAt => {
    if (expiresAt == null) {
        return false;
    }

    const now = new Date();
    const expiresDate = parseISO(expiresAt);

    return now < expiresDate && now > sub(expiresDate, { hours: isExpiringInterval });
};
